$(function () {
    $(".ar-document-list-block").on("click", ".ar-document-list-block__show-more-link", function (e) {
        e.preventDefault();

        $(this)
            .hide()
            .siblings(".ar-document-list-block__document-list-container_hidden")
            .removeClass("ar-document-list-block__document-list-container_hidden");
    });
});